import { makeAutoObservable, runInAction } from 'mobx';
import {
  ElectricReport,
  IElectricityPayment,
  IElectricityPaymentDelete,
  IElectricityPaymentDetailsParam,
  IElectricityPaymentParams,
  IElectricityPaymentReport,
  IGetHistoryParam,
  IRecievePayment,
} from 'src/@types/Choqorak/MainTables/ElectricityPayment/ElectricityPayment';
import agent from 'src/api/agent';
import ElectricMeterStore from '../../Settings/ElectricMeterStore';
export default class ElectricityPaymentStore {
  openDialog = false;

  openCreateDialog = false;

  openGeneratRentListDialog = false;

  ElectricityPaymentList: IElectricityPayment[] = [];

  ElectricityPaymentRegistry = new Map<number, IElectricityPayment>();

  editMode = false; //When click on edit button

  ElectricMeterStoreObj = new ElectricMeterStore();

  selectedElectricityPayment: IElectricityPayment | undefined = undefined;

  selectedElectricityPaymentDetail: IElectricityPayment | undefined = undefined;

  ElectricitypaymentReportResult: ElectricReport | undefined;

  ElectricityPaymentHistoryResult: IElectricityPayment[] | undefined;

  totalRecord: number = 0;

  openConsuptionDialog = false;

  openEletricDetailsDialog = false;

  openDeleteDialog = false;

  constructor() {
    makeAutoObservable(this);
  }

  //Pagination
  loadElectricityPayment = async (params: IElectricityPaymentParams) => {
    // this.ElectricityPaymentRegistry.clear();

    const result = await agent.ElectricityPayment.getList(params);
    console.log(result.data);
    runInAction(() => {
      this.ElectricityPaymentList = result.data;
    });
  };

  clearSelectedElectricityPayment = () => {
    this.editMode = false;
    this.selectedElectricityPayment = undefined;
    this.selectedElectricityPaymentDetail = undefined;
  };

 

  setOpenCloseDialog = () => (this.openDialog = !this.openDialog);

  setOpenCloseCreateDialog = () => (this.openCreateDialog = !this.openCreateDialog);

  setOpenCloseUpdateDialog = () => (this.openConsuptionDialog = !this.openConsuptionDialog);

  setOpenCloseEletricDetailsDialog = () => (this.openEletricDetailsDialog = !this.openEletricDetailsDialog);

  setOpenCloseDeleteDialog = () => (this.openDeleteDialog = !this.openDeleteDialog);

  setOpenCloseGeneratRentListDialog = () =>
    (this.openGeneratRentListDialog = !this.openGeneratRentListDialog);

  createElectricityPayment = async (ElectricityPayment: IElectricityPayment) => {
    await agent.ElectricityPayment.create(ElectricityPayment);

    runInAction(() => {});
  };

  RecievePayment = async (data: IRecievePayment) => {
    await agent.ElectricityPayment.RecievePayment(data, data.attachment);
    runInAction(() => {
      // this.loadElectricityPayment({ pageIndex: 0, pageSize: 5 });
      // this.clearSelectedElectricityPayment();
    });
  };

  updateElectricityPayment = async (ElectricityPayment: IElectricityPayment) => {
    await agent.ElectricityPayment.update(ElectricityPayment);

    runInAction(() => {
      // this.clearSelectedElectricityPayment();
    });
  };

  loadElectricityPaymentReport = async (reportParams: IElectricityPaymentReport) => {
    // this.ElectricitypaymentReportResult = undefined;
    const axiosResponse = await agent.ElectricityPayment.getElectricityPaymentReport(reportParams);

    runInAction(() => {
      this.ElectricitypaymentReportResult = axiosResponse.data;
    });
  };

  loadElectricityPaymentDailyReport = async (reportParams: IElectricityPaymentReport) => {
    // this.ElectricitypaymentReportResult = undefined;
    const axiosResponse = await agent.ElectricityPayment.getElectricityPaymentDailyReport(
      reportParams
    );

    runInAction(() => {
      this.ElectricitypaymentReportResult = axiosResponse.data;
    });
  };

  loadElectricityPaymentDetail = async (param: IElectricityPaymentDetailsParam) => {
    const getRenPaymentDetail = await agent.ElectricityPayment.getDetail(param);
    runInAction(() => {
      this.selectedElectricityPaymentDetail = getRenPaymentDetail;
    });
  };

  GetElectricityPaymentHistory = async (reportParams: IGetHistoryParam) => {
    const axiosResponse = await agent.ElectricityPayment.GetHistory(reportParams);

    runInAction(() => {
      this.ElectricityPaymentHistoryResult = axiosResponse.data;
    });
  };


  deleteElectricityPaymentInfo = async (param:IElectricityPaymentDelete) => {
    await agent.ElectricityPayment.delete(param);
    runInAction(() => {
     
      this.setOpenCloseDeleteDialog();
    });
  };
}
